import { Suspense, lazy, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router';

import dayjs from 'dayjs';
import 'dayjs/locale/de';
import isToday from 'dayjs/plugin/isToday';
import 'swiper/css';

import '@bluecodecom/fonts';

import { LoaderProvider } from '@bluecodecom/loader';

import { ThemeProvider } from '@bluecodecom/theme';

import { nativeService } from '@bluecodecom/native';

import { trackingHooks } from '@bluecodecom/sdk-feedback-webview/features/tracking';

import './i18n';

dayjs.extend(isToday);

const App = lazy(() => import('./app'));

const Main = () => {
  const {
    i18n: { language },
  } = useTranslation();
  useEffect(() => {
    nativeService.allowResumeMiniApp();
    nativeService.hideNavigation();
    dayjs.locale(language || 'de');
  }, [language]);

  // Legacy-only: this wraps the router and stays mounted for the session, so
  // reporting it as a screen would put a phantom step in front of every
  // deep-linked screen.
  trackingHooks.useTrackEvent('Opened');

  return (
    <LoaderProvider>
      <ThemeProvider observe>
        <BrowserRouter>
          <Suspense>
            <App />
            <div className="h-4 left-0 w-full bottom-0 fixed z-10 bg-[linear-gradient(180deg,_transparent_0%,#F4F2F6_100%)] dark:bg-[linear-gradient(0deg,_#252527_0%,_transparent_100%)]" />
          </Suspense>
        </BrowserRouter>
      </ThemeProvider>
    </LoaderProvider>
  );
};

createRoot(document.getElementById('root') as HTMLElement).render(<Main />);
